<template>
  <div class="view-job-details">
    <b-alert v-if="jobIsInActive" variant="warning" show style="text-align: center"
      >This job is no longer active
    </b-alert>

    <b-alert v-if="jobIsPreview" variant="secondary" show style="text-align: center; color: #66676b"
      >This job is under review and not public yet</b-alert
    >
    <div v-if="jobIsClaimable">
      <div class="bg-primary text-center text-white p-3">
        <button class="btn btn-link text-white" @click="openClaimModal">
          <b><u>Claim this job offer</u></b>
        </button>
        and take ownership of the startup and its other job offers
      </div>
    </div>

    <JobsPageContent
      :job="job"
      :related="isPreview ? [] : relatedJobs"
      :is-careers-page="isPreview"
    />

    <StickyUntil
      v-if="['676171b172a56b2f647f0d7a'].includes(job.id)"
      :stopAtId="'thehub_footer'"
      :offset="16"
      :right="16"
    >
      <!-- <StickyBlock
      v-if="['676171b172a56b2f647f0d7a'].includes(job.id)"
      backgroundColor="rgba(0,0,0,0)"
      left="unset"
      right="0.5rem"
    > -->
      <div
        style="
          width: 300px;
          height: 375px;
          background: #c27b7f;
          border-radius: 32px;
          box-shadow: 0 2px 10px rgba(0,0,0,0.1);
        "
      >
        <iframe
          src="https://vouch.careers/embeded/cm9buxv8g0002gj0de825oxii/widget"
          data-vouch-embeded="cm9buxv8g0002gj0de825oxii"
          style="width: 100%; height: 100%; border: none"
        ></iframe>
      </div>
      <!-- </StickyBlock> -->
    </StickyUntil>

    <Container v-else width="big" spacing="small" plr-none>
      <StickyBlock v-if="!jobIsClaimable && jobIsActive">
        <b-row class="p-16 border-top">
          <b-col class="d-flex align-items-center justify-content-end">
            <button class="btn px-60" @click.prevent="isApplyOpen = true">
              Apply
            </button>
          </b-col>
        </b-row>
      </StickyBlock>
    </Container>

    <ScrapedJobsApplyModal
      v-if="isScraped() || hasJobProviderLink()"
      v-model="isApplyOpen"
      :job="job"
      @submitted="onSubmitted"
    />
    <JobsApplyModal v-else v-model="isApplyOpen" :job="job" @submitted="onSubmitted" />
    <StartupClaim ref="claimStartupModal" :startup="job.company" button-text="Claim job" />

    <ScrapedJobsSignUpModal v-model="isSignUpOpen" />

    <component
      :is="userIsLoggedIn ? 'ApplicationSent' : 'JobsApplicationSent'"
      v-model="isApplicationSent"
      :success-data="successData"
      :related="relatedJobs"
    />
  </div>
</template>

<script>
import Container from '@/components/Container';
import StickyBlock from '@/components/StickyBlock.vue';
import StickyUntil from '@/components/StickyUntil.vue';
import JobsPageContent from '@/components/jobs/JobsPageContent';
import JobsApplyModal from '@/modals/jobs/JobsApply';
import ScrapedJobsApplyModal from '@/modals/jobs/ScrapedJobsApply';
import ScrapedJobsSignUpModal from '@/modals/jobs/ScrapedJobsSignUp';
import ApplicationSent from '@/modals/ApplicationSent';
import JobsApplicationSent from '@/modals/jobs/JobsApplicationSent';
import StartupClaim from '@/components/startups/StartupClaim';
import { buildMetaHead } from '@/helpers/meta';
import get from 'lodash/get';
import uniq from 'lodash/uniq';

export default {
  name: 'PageJobsId',
  components: {
    Container,
    StickyBlock,
    JobsPageContent,
    JobsApplyModal,
    ScrapedJobsApplyModal,
    ScrapedJobsSignUpModal,
    ApplicationSent,
    JobsApplicationSent,
    StartupClaim,
    StickyUntil
  },
  layout({ query }) {
    const isPreview = query.careerPagePreview ? true : false;
    return isPreview ? 'careers' : 'default';
  },
  head() {
    return buildMetaHead({
      title: this.job.title + ' | ' + this.job.company.name,
      description: this.job.description
        .replace(/(<([^>]+)>)/gi, ' ')
        .substr(0, 255)
        .trim(),
      path: this.job.url,
      imageUrl: this.job.socialImageUrl,
      googleJob: this.mapToGoogleJob(this.job)
    });
  },
  data: () => ({
    isApplyOpen: false,
    isSignUpOpen: false,
    isApplicationSent: false,
    applicant: {},
    showVouchWidget: true
  }),
  computed: {
    userIsLoggedIn() {
      return this.$store.getters['user/isLoggedIn'];
    },
    job() {
      return this.$store.state.jobs.job;
    },
    jobIsInActive() {
      return ['EXPIRED', 'STOPPED'].includes(this.job.status);
    },
    jobIsPreview() {
      return this.job.isDraft || this.job.isPending;
    },
    jobIsActive() {
      return this.job.status === 'ACTIVE';
    },
    jobIsClaimable() {
      return this.job.company.claim === true;
    },
    relatedJobs() {
      return this.$store.state.jobs.relatedJobs;
    },
    isPreview() {
      return get(this.$route, 'query.careerPagePreview', false) ? true : false;
    },
    successData() {
      return {
        title: 'Application sent!',
        subtitle:
          this.job.company.name +
          ' will contact you if your skills and experiences are a strong match.',
        applicant: this.applicant,
        image: 'ilustration01.jpg',
        link: '/jobs',
        label: 'Browse more similar jobs',
        width: 360
      };
    }
  },
  async asyncData({ params, store, error }) {
    try {
      await store.dispatch('jobs/get', params.id);
    } catch (err) {
      error(err);
    }
  },
  async mounted() {
    try {
      await this.$store.dispatch('jobs/getRelated', this.job.id);
    } catch (err) {
      console.error(err);
    }
  },
  beforeDestroy() {
    // remove Talent.com Pixel
    let el = document.getElementById('talent-pixel');
    if (el) {
      el.remove();
    }
  },
  methods: {
    isScraped() {
      return !!this.job.scraped;
    },
    hasJobProviderLink() {
      // console.log('this.job', this.job);
      return !!this.job.link;
    },
    async onSubmitted(data) {
      this.applicant = {
        name: data.name,
        email: data.email,
        phone: data.phone
      };

      this.isApplyOpen = false;
      if (this.isScraped() || this.hasJobProviderLink()) {
        if (!this.userIsLoggedIn) {
          this.isSignUpOpen = true;
        }
      } else {
        this.isApplicationSent = true;
      }

      this.addTalentComPixel();

      // reload profiles
      await this.$store.dispatch('user/load');
    },
    positionTypes() {
      return this.$store.getters['meta/jobPositionTypes'].map((item) => ({
        text: item.label,
        value: item.id
      }));
    },
    addTalentComPixel() {
      // To track received applications for Talent.com
      const img = document.createElement('img');
      img.setAttribute('id', 'talent-pixel');
      img.src = 'https://www.talent.com/tracker/img-pixel.php?tracker=the_hub';
      document.body.appendChild(img);
    },
    mapGoogleEmploymentType(jobPositionTypes) {
      const positionTypes = this.positionTypes();

      let tempArr = [];
      jobPositionTypes.forEach((element) => {
        tempArr.push(
          positionTypes.find((item) => {
            return item.value === element;
          })
        );
      });

      let googleArr = [];

      //Cofounder
      //Student

      // FULL_TIME: The job is a full-time position.
      // PART_TIME: The job is a part-time position.
      // CONTRACTOR: The job is a contractor position.
      // TEMPORARY: The job is a temporary position.
      // INTERN: The job is an internship position.
      // VOLUNTEER: The job is a volunteer position.
      // PER_DIEM: The job is paid by the day.
      // OTHER: The job is a different type of position that's not covered by the other possible values.
      tempArr.forEach((item) => {
        if (item.text === 'Full-time') {
          googleArr.push('FULL_TIME');
        } else if (item.text === 'Part-time') {
          googleArr.push('PART_TIME');
        } else if (item.text === 'Internship') {
          googleArr.push('INTERN');
        } else if (item.text === 'Student') {
          googleArr.push('INTERN');
          googleArr.push('OTHER');
        } else if (item.text === 'Freelance') {
          googleArr.push('CONTRACTOR');
        } else if (item.text === 'Cofounder') {
          googleArr.push('OTHER');
        } else if (item.text === 'Advisory board') {
          googleArr.push('PART_TIME');
          googleArr.push('CONTRACTOR');
        } else {
          googleArr.push('OTHER');
        }
      });
      // remove duplicates
      const uniqueArr = uniq(googleArr);

      return uniqueArr;
    },
    mapToGoogleJob(job) {
      if (job.status !== 'ACTIVE') {
        return null;
      }

      let googleJobObj = {
        '@context': 'https://schema.org/',
        '@type': 'JobPosting'
      };

      // Required properties
      googleJobObj.title = job.title;
      googleJobObj.datePosted = job.createdAt;
      googleJobObj.description = job.description;
      googleJobObj.validThrough = job.expirationDate;
      googleJobObj.hiringOrganization = {
        '@type': 'Organization',
        name: job.company.name,
        sameAs: job.company.website,
        logo: job.company.logoImage.thumbnailSizeUrl
      };
      // //////////////////////////////////////////////////////////////////////////////////

      // mb it's worth to use the TEXT type of the address????????????
      // jobLocationType	Text for the remote jobs is suggested by google

      const companyLocations = [];
      for (const countryCode in job.companyCountries) {
        if (job.companyCountries[countryCode].status === 'ACTIVE') {
          companyLocations.push(job.companyCountries[countryCode].location);
        }
      }

      if (job.isRemote && job.location) {
        googleJobObj.jobLocationType = 'TELECOMMUTE';

        if (job.location.address !== '') {
          googleJobObj.applicantLocationRequirements = {
            '@type': 'Country',
            name: job.location.country || ''
          };
        } else {
          const companyLocation = companyLocations[0];
          googleJobObj.applicantLocationRequirements = !companyLocation
            ? {}
            : {
                '@type': 'Country',
                name: companyLocation.country || ''
              };
        }
      }

      if (job.isRemote && !job.location) {
        googleJobObj.jobLocationType = 'TELECOMMUTE';
        googleJobObj.applicantLocationRequirements = companyLocations.map((location) => ({
          '@type': 'Country',
          name: location.country || ''
        }));
      }

      if (!job.isRemote && job.location) {
        if (job.location.address !== '') {
          googleJobObj.jobLocation = {
            '@type': 'Place',
            address: {
              '@type': 'PostalAddress',
              addressCountry: job.location.country || '',
              addressLocality: job.location.locality || '',
              addressRegion: job.location.locality || '',
              postalCode: job.location.postalCode || '',
              streetAddress: job.location.route || ''
            }
          };
        } else {
          const companyLocation = companyLocations[0];
          googleJobObj.jobLocation = !companyLocation
            ? {}
            : {
                '@type': 'Place',
                address: {
                  '@type': 'PostalAddress',
                  addressCountry: companyLocation.country || '',
                  addressLocality: companyLocation.locality || '',
                  addressRegion: companyLocation.locality || '',
                  postalCode: companyLocation.postalCode || '',
                  streetAddress: companyLocation.route || ''
                }
              };
        }
      }

      if (!job.isRemote && !job.location) {
        const companyLocation = companyLocations[0];
        googleJobObj.jobLocation = !companyLocation
          ? {}
          : {
              '@type': 'Place',
              address: {
                '@type': 'PostalAddress',
                addressCountry: companyLocation.country || '',
                addressLocality: companyLocation.locality || '',
                addressRegion: companyLocation.locality || '',
                postalCode: companyLocation.postalCode || '',
                streetAddress: companyLocation.route || ''
              }
            };
      }

      // //////////////////////////////////////////////////////////////////////////////////

      /*
      if (!job.isRemote && job.location) {
        // "Standard job posting"

        googleJobObj.jobLocation = {
          '@type': 'Place',
          address: {
            '@type': 'PostalAddress',
            streetAddress: job.location.address,
            addressLocality: job.location.locality,
            addressRegion: job.location.locality,
            postalCode: job.location.postalCode,
            addressCountry: job.location.country
          }
        };
      } else if (job.isRemote || !job.location) {
        // "Work from home job posting"
        if (job.companyCountries) {
          // console.log('TELECOMMUTE LOCATION', job.companyCountries);
          const locations = [];
          for (const countryCode in job.companyCountries) {
            if (job.companyCountries[countryCode].status === 'ACTIVE') {
              // comapny country:
              // address: 'Strandvägen 47, 114 56 Stockholm, Sweden';
              // country: 'Sweden';
              // locality: 'Sweden';
              // postalCode: '114 56';
              // route: 'Strandvägen';
              locations.push(job.companyCountries[countryCode].location);
            }
          }
          // "applicantLocationRequirements": {
          //   "@type": "Country",
          //   "name": "USA"
          // },
          googleJobObj.applicantLocationRequirements = locations.map((location) => ({
            '@type': 'Country',
            name: location.country
          }));
        }
        googleJobObj.jobLocationType = 'TELECOMMUTE';
      }
      */

      // Recommended properties
      googleJobObj.directApply = 'true';
      googleJobObj.employmentType = this.mapGoogleEmploymentType(job.jobPositionTypes);
      googleJobObj.identifier = {
        '@type': 'PropertyValue',
        name: job.company.name,
        value: job.id
      };
      return JSON.stringify(googleJobObj);
    },
    openClaimModal() {
      this.$refs.claimStartupModal.openClaimModal();
    }
  }
};
</script>

<style scoped lang="scss">
.view-job-details {
  @include media-breakpoint-down(sm) {
    .bullet-inline-list {
      margin-top: rem(8px);

      a {
        display: block;
        margin-bottom: rem(1px);

        &:before {
          display: none;
        }
      }
    }
  }

  .company-image {
    max-width: 100%;
  }
}
</style>
